import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; 



const splashScreen = {
  enabled: true,
  animation: splashAnimation,
  duration: 2000 
};



const illustration = {
  animated: true 
};

const greeting = {
  username: "Ansh Kumar",
  title: "Hi all, I'm Ansh",
  subTitle: emoji(
    "A dynamic Learner 🚀 experienced in startup environments, adept at problem-solving and crafting web solutions with React.js/Node. Let's innovate together!"
  ),
  resumeLink:
    "https://drive.google.com/file/d/1OlAQGzDfXfYmB8-6x4kSpVKV6TQ6mEs3/view?usp=sharing", 
    //next step make a download button on the side
    displayGreeting: true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/meanshkumar",
  linkedin: "https://www.linkedin.com/in/meanshkumar/",
  gmail: "im.ansh1410@gmail.com",
  facebook: "https://www.facebook.com/meanshkumar",
  instagram: "https://www.instagram.com/meanshkumar",
  // gitlab: "https://gitlab.com/meanshkumar",
  medium: "https://medium.com/@meanshkumar",
  // stackoverflow: "https://stackoverflow.com/users/23169439/ansh-kumar",
   display: true 
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "PROGRAMMER WHO WANTS TO EXPLORE EVERY TECHNOLOGY AND WORLD, A BIT LAZY ONE :) ",
  skills: [
    emoji(
     
      "⚡ Develop  Front end / User Interfaces for web applications"
    ),
    emoji("⚡ Database, Data analyzing, cleaning , visualizing"),
    emoji(
      "⚡ Familiar to technologies like Git, AWS, Google cloud "
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
   
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "Google cloud",
      fontAwesomeClassname: "fab fa-google"
    },

    {
      skillName: "Git",
      fontAwesomeClassname: "fab fa-git-alt"
    },
    {
      skillName: "Github",
      fontAwesomeClassname: "fab fa-github"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    // {
    //   skillName: "docker",
    //   fontAwesomeClassname: "fab fa-docker"
    // }
  ],
  display: true 
};

// Education Section

const educationInfo = {
  display: true, 
  schools: [
    {
      schoolName: "Institute of engineering and Management",
      logo: require("./assets/images/IEM_logo.png"),
      subHeader:"B.tech in Electrical & Electronics Engineering",
      duration: "September 2021 - April 2025",
      desc: "Participated in various Hackathons and published 1 papers.",
      descBullets: [
        "Organizing Team for Kolkata Police Tech Hackathon 2022",
        "Google Kickstart 2022 Round G",
        "Participated and completed Hacktoberfest 2022"
      ]
    },
    {
      schoolName: "Sushant Public School",
      logo: require("./assets/images/sps_logo.jpeg"),
      subHeader: "Intermediate",
      duration: "June 2019 - July 2021",
      desc: "PCM(Science), English & Fine Arts  - 87%",
      descBullets: [
        "Played badminton at interschool tournament",
        "Participated in Interschool powerlifting competition"
      ]
    },
    {
      schoolName: "DAV PS Malighat",
      logo: require("./assets/images/DAV_logo.png"),
      subHeader: "Matriculation",
      duration: "April 2018 - May 2019",
      desc: "Maths, Science, Computer, English, Sanskrit  - 93%.",
      descBullets: ["Won national Children Science Congress 2018 (District)"]
    }
  ]
};


const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "70%" //Insert relative proficiency in percentage
    },
    {
      Stack: "SQL",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "80%"
    }
  ],
  displayCodersrank: true // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true,
  experience: [
     {
      role: "Freelancer",
      company: "Meshwork technologies Pvt. Ltd.",
      companylogo: require("./assets/images/MtLogo.jpeg"),
      date: "Jan 2023 – Present",
      desc: "Work on project basis on MERN stack. Frontend Web Designing/Development using HTML, CSS, JS & Figma"
    },
    {
      role: "Tutor",
      company: "Edook",
      companylogo: require("./assets/images/EdookLogo.png"),
      date: "October 2022 – Present",
      desc: "I work as a part time computer science, Physics and & mathematics tutor ",
      descBullets: [
        "Gained confidence in communication & Subject knowledge.",
        "Teaching students online across the globe taught me Punctuallity & scheduling"
      ]
    },
    {
      role: "Campus Ambassador",
      company: "GeeksforGeeks",
      companylogo: require("./assets/images/GfgLogo.png"),
      date: "August 2022 – October 2023",
      desc: "Organised various Events and meetings such as regarding programming awareness, Talks on new-age Technologies and its applications"
    }
   
  ]
};

const openSource = {
  showGithubProfile: "true", 
  display: true 
};

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPs & BIG PROJECTS I'M WORKING ON",
  projects: [
    {
      image: require("./assets/images/Admpath.png"),
      projectName: "AdmPath",
      projectDesc: "Educational Information platform which deals in career counselling",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.admpath.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    // {
    //   image: require("./assets/images/calculator.png"),
    //   projectName: "Calci",
    //   projectDesc: "Javascript based app",
    //   footerLink: [
    //     {
    //       name: "Visit Website",
    //       url: ""
    //     }
    //   ]
    // },
    
  ],
  display: true
};


const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "AWS Cloud Practitioner Essentials",
      subtitle:
        "Understand the working & definition of global infrastructure of the AWS Cloud.",
      image: require("./assets/images/aws.jpeg"),
      imageAlt: "aws-cloud logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://coursera.org/share/dd38ce61807e517800098623841b271d"
        },
      
      ]
    },
    {
      title: "Google Data Analytics ",
      subtitle:
        "Skills in data analysis, visualization, and querying, vital for interpreting complex data sets",
      image: require("./assets/images/google.png"),
      imageAlt: "Google Logo",
      footerLink: [
        {
          name: "Certificate",
          url: "https://coursera.org/share/cb03e6dafd0bf89b6442d59ca2227a77"
        }
      ]
    },

    {
      title: "Complete Web Development ",
      subtitle: "Completed Certifcation from udemy on full stack wen development",
      image: require("./assets/images/Udemy.png"),
      imageAlt: "PWA Logo",
      footerLink: [
        {name: "Certification", url: ""},
        // {name: "Projects", url: ""}
      
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    
    {
      url: "https://medium.com/@meanshkumar/how-to-start-with-coding-101-edd4f1f75141",
      title: "How to start with coding 101",
      description:
        "This is the most layman’s and old school approach to get a dive into programming."
    }
  ],
  display: true 
};

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    ""
  ),

  talks: [
    {
      title: "",
      subtitle: "",
      slides_url: "",
      event_url: ""
    }
  ],
  display: false 
};


const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  podcast: [
    ""
  ],
  display: false 
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+91-8102961607",
  email_address: "im.ansh1410@gmail.com"
};


const twitterDetails = {
  userName: "meanshkumar", //username without @
  display: false 
};

const isHireable = true; 
export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
